import apiClient from '@/services/axios';

export async function del(id) {
  const response = await apiClient.delete(`/recurringNotifications/${id}`);
  if (response) {
    return response.data;
  }
  throw new Error('Unable to delete recurring notification.');
}
